import React from 'react';
import DatePicker from "react-datepicker";
import {FormGroup, Label} from 'reactstrap';

import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage } from 'react-intl';

const ReduxFormDatePicker: React.FC = (field: any) => (
  <FormGroup row={false}>
    {field.label && (<Label><FormattedMessage {...field.label} /></Label>)}
    <DatePicker
      className={'form-control'}
      {...field.input}
      selected={field.input.value}
      dateFormat="dd/MM/yyyy" />
    {field.meta.touched && field.meta.error && (
      <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
    )}
  </FormGroup>
);

export default ReduxFormDatePicker;